import { render } from "./ConfigurationEditDialog.vue?vue&type=template&id=406a7776"
import script from "./ConfigurationEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigurationEditDialog.vue?vue&type=script&lang=js"

import "./ConfigurationEditDialog.vue?vue&type=style&index=0&id=406a7776&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
